<template>
  <div v-if="timestamp !== null">
    <div>
      {{ formatTimeUserZone(timestamp, true) }}
    </div>
    <div>
      {{ formatTime(timestamp, getComputedTimeZone(), true) }}
    </div>
  </div>
</template>

<script>
	import {mapState} from 'vuex'
	import {formatTime, formatTimeUserZone} from '@/utils/time'

	export default {
  components: {},
  props: {
    timestamp: { type: Number, default: null },
    timeZoneName: { type: String, default: null },
    gateway: { type: String, default: null },
    source: { type: String, default: null },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('user', ['comparisonSourceLookup', 'gatewayLookup']),
  },
  methods: {
    formatTime,
    formatTimeUserZone,
    getComputedTimeZone: function() {
      if (this.timeZoneName !== null) {
        return this.timeZoneName
      } else if (this.gateway !== null) {
        return this.gatewayLookup[this.gateway].timeZone
      } else {
        throw 'Time zone not set'
      }
    },
  },
}
</script>

<style lang="scss"></style>
